import { render, staticRenderFns } from "./consumeRank.vue?vue&type=template&id=5390d3ef"
import script from "./consumeRank.vue?vue&type=script&lang=js"
export * from "./consumeRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports